import React, { useEffect } from 'react'
import { useState } from 'react'
import { Link,useLocation } from 'react-router-dom'
import { useRef } from 'react'
import { ReactComponent as BookmarkIcon} from '../../../images/icons/Bookmark.svg'
import { ReactComponent as NotificationIcon} from '../../../images/icons/Notification.svg'
import { ReactComponent as NotificationActiveIcon} from '../../../images/icons/Notification_Active.svg'
import { ReactComponent as HeartIcon} from '../../../images/icons/like.svg'
import { ReactComponent as UserIcon} from '../../../images/icons/User.svg'
import { ReactComponent as CommentIcon} from '../../../images/icons/Message.svg'
import { ReactComponent as MessageChatIcon} from '../../../images/icons/MessageChat.svg'
import { ReactComponent as CartIcon} from '../../../images/icons/cart.svg'
import { ReactComponent as MenuBarIcon} from '../../../images/icons/menubar.svg'
import { ReactComponent as HomeIcon} from '../../../images/icons/Dashboard.svg'
import {ReactComponent as BookmarksIcon} from '../../../images/icons/Bookmark_Active.svg'
import {ReactComponent as ListingIcon} from '../../../images/icons/Listing.svg'
import {ReactComponent as HelpIcon} from '../../../images/icons/Setting.svg'
import {ReactComponent as InsighsIcon} from '../../../images/icons/Insight.svg'
import {ReactComponent as OrdersIcon} from '../../../images/icons/Orders.svg'
import {ReactComponent as SalesIcon} from '../../../images/icons/Sales.svg'
import {ReactComponent as ShareIcon} from '../../../images/icons/share.svg'
import {ReactComponent as CrossIcon} from '../../../images/icons/add.svg'
import {ReactComponent as FacebookIcon} from '../../../images/public/footer/facebook.svg'
import {ReactComponent as TwitterIcon} from '../../../images/public/footer/twitter.svg'
import {ReactComponent as InstagramIcon} from '../../../images/public/footer/instagram.svg'
import {ReactComponent as PinterestIcon} from '../../../images/public/footer/pinterest.svg'
import {ReactComponent as LinkedinIcon} from '../../../images/public/footer/linkedin.svg'
import {ReactComponent as YoutubeIcon} from '../../../images/public/footer/youtube.svg'
import SignUpButton from '../../forms/blackfillButton'
import ApiUrl from '../../../configTools/apiUrl'
import Button from '../../forms/blackfillButton'
import LightButton from '../../forms/lightfillButton'
import ScreenSizes from '../../../configTools/screenSizes'
import ChatFunctions from '../../../functions/public/chat'
import UserFunctions from '../../../functions/public/user'


const RightNav = ({cartBoxToggle,Bag,menuOpen,setMenuOpen,openChatBox,setOpenChatBox}) => {
    const currentRoute = useLocation().pathname.toLowerCase();
  const User = JSON.parse(localStorage.getItem("user-info"));
  const ChatBoxes = JSON.parse(localStorage.getItem("chat-boxes"));

  const addChatBox = (item)=>{
    var newchatboxes = [];
    var exist = false;
    if(ChatBoxes){
      for (let index = 0; index < ChatBoxes.length; index++) {
        const element = ChatBoxes[index];
        newchatboxes.push(element)
        if(element.id == item.id){
          setOpenChatBox(element);
          exist = true;
        }
      }
    }
    if(!exist){
        newchatboxes.push(item);
        localStorage.setItem("chat-boxes",JSON.stringify(newchatboxes));
        setOpenChatBox(item);
    }
  }

  const myaccountBox = useRef(null);
  const menuwrapperBox = useRef(null);
  const menucontainerBox = useRef(null);
  function Toggle2(open){
    if(open){
        myaccountBox.current.className = 'rightnav_myprofile_dropdown active';
    }
    else{
        setTimeout(() => {
            myaccountBox.current.className = 'rightnav_myprofile_dropdown';
        }, 300);
    }
  }
  useEffect(()=>{
    if(menuOpen){
        menuwrapperBox.current.className = 'right_menu active';
        setTimeout(() => {
            menucontainerBox.current.className = 'right_menu_container active';
        }, 500);
    }
    else{
        menucontainerBox.current.className = 'right_menu_container';
        setTimeout(() => {
            menuwrapperBox.current.className = 'right_menu';
        }, 500);
    }
  },[menuOpen])

  const [notifications,setNotifications] = useState([]);
  const [unreadnotification,setUnreadnotification] = useState([]);
  const [noteactive,setNoteActive] = useState(false);
  const notificationBox = useRef(null);
  function ToggleNote(open){
    if(open){
        notificationBox.current.className = 'rightnav_notification_dropdown active';
        setNoteActive(true);
        read_notifications();
    }
    else{
        setTimeout(() => {
            notificationBox.current.className = 'rightnav_notification_dropdown';
            setNoteActive(false);
        }, 300);
    }
  }



  const [rooms,setRooms] = useState([]);
  //const [roomactive,setRoomActive] = useState(false);
  const roomBox = useRef(null);
  function ToggleRoom(open){
    if(open){
        roomBox.current.className = 'rightnav_notification_dropdown active';
        //setRoomActive(true);
    }
    else{
        setTimeout(() => {
            roomBox.current.className = 'rightnav_notification_dropdown';
            //setRoomActive(false);
        }, 300);
    }
  }

  const SignOut = () =>{
      localStorage.removeItem('user-info');
      document.location.reload();
  }

  const read_notifications = ()=>{
    if(unreadnotification.length === 0){
        return;
    }
    if(User){
        fetch(ApiUrl.API_URL_Notification,{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(unreadnotification)
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.success){
                Refresh_notifications()
            }
        });
        setTimeout(() => {
            Refresh_notifications();
        }, 30000);
    }
  }

  const Refresh_notifications = ()=>{
    if(User){
        fetch(ApiUrl.API_URL_Notification,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            }
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.success){
                setNotifications(data.responce);
                var counter = [];
                data.responce.forEach(item => {
                    if(item.read === false){
                        counter.push(item);
                    }
                });
                setUnreadnotification(counter);
            }
        });
        setTimeout(() => {
            Refresh_notifications();
        }, 30000);
    }
  }

  useEffect(()=>{
    if(User){
        fetch(ApiUrl.API_URL_Notification,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            }
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.success){
                setNotifications(data.responce);
                var counter = [];
                data.responce.forEach(item => {
                    if(item.read === false){
                        counter.push(item);
                    }
                });
                setUnreadnotification(counter);
            }
        });
        setTimeout(() => {
            Refresh_notifications();
        }, 30000);
        ChatFunctions.GetRoom(setRooms);
    }
    UserFunctions.UserInfo();
  },[])

  const width = window.innerWidth;

  const showPreview = (e) =>{
    if(e.target.files && e.target.files[0]){
        let imageFile = e.target.files[0];
        const formData = new FormData();
        formData.append("file",imageFile);
        fetch(ApiUrl.API_URL_File, {
            method: 'POST',
            body: formData
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.success){
                fetch(ApiUrl.Profile, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer '+User.token
                    },
                    body: JSON.stringify({
                        Id:User.id,
                        discription: User.discription,
                        firstname : User.firstname,
                        lastname : User.lastname,
                        address : User.address,
                        cnic : User.cnic,
                        contact : User.contact,
                        email : User.email,
                        location : User.location,
                        image : data.url
                    })
                  })
                  .then(res2=>res2.json())
                  .then(data2 =>{
                    if(data2.success){
                        let userNew = User;
                        userNew.image = data.url;
                        localStorage.setItem("user-info",JSON.stringify(userNew));
                        document.location.reload();
                    }
                    else{
                        console.log(data2.responce);
                    }
                });
            }
            else{
                console.log(data.responce);
            }
        });
    }
}

  return (
    <div className='header_rightnav_wrapper'>
        <div className='right_nav_container'>
            {width > ScreenSizes.Mobile &&
                <Link to='/dashboard/bookmarks'>
                <div className='right_nav_element'>
                    <BookmarkIcon width='22px' height='40px'/>
                </div>
                </Link>
            }
            {User == null && width > ScreenSizes.Mobile &&
                <>
                <Link to={"#"}>
                    <div className='right_nav_element' onClick={cartBoxToggle} style={{
                        position:"relative"
                    }}>
                        <CartIcon width='22px' height='40px'/>
                        <div className='cart_counter'>
                            {Bag &&
                                <p>{Bag.length}</p>
                            }
                            </div>
                    </div>
                </Link>
                    <Link to='/signup'>
                        <div className='right_nav_element'>
                                <SignUpButton  Value="SIGN UP"  Type = 'button' />
                        </div>
                    </Link>
                    <Link to='/login'>
                        <div className='right_nav_element'>
                            <h5>Login</h5>
                        </div>
                    </Link>
                </>
            }
            {User !== null && width > ScreenSizes.Mobile &&
                <>
                    <Link to='/dashboard/liked'>
                        <div className='right_nav_element'>
                            <HeartIcon width='22px' height='40px'/>
                        </div>
                    </Link>
                    <Link to='#'>
                        <button className='right_nav_element' onFocus={()=>{ToggleRoom(true)}} onBlur={()=>{ToggleRoom(false)}}>
                            <MessageChatIcon width='22px' height='40px'/>
                        </button>
                    </Link>
                    <Link to='#'>
                        <button className='right_nav_element' style={{
                                    position:'relative'
                                }} onFocus={()=>{ToggleNote(true)}} onBlur={()=>{ToggleNote(false)}}  onClick={ToggleNote}>
                            {noteactive &&
                                <NotificationIcon width='22px' height='40px'/>
                            }
                            {!noteactive && unreadnotification.length > 0 &&
                            <>
                            <NotificationActiveIcon width='22px' height='40px'/>
                                    <div className='notification_counter'><p>{unreadnotification.length > 9? 9 : unreadnotification.length}</p></div>
                                    {unreadnotification.length > 9 &&
                                    <div className='notification_counter_extra'><p>{'+'}</p></div>
                                    }
                            </>
                            }
                            {!noteactive && unreadnotification.length === 0 &&
                                <NotificationIcon width='22px' height='40px'/>
                            }
                        </button>
                    </Link>
                    <Link to={"#"}>
                        <div className='right_nav_element' onClick={cartBoxToggle} style={{
                            position:"relative"
                        }}>
                            <CartIcon width='22px' height='40px'/>
                            <div className='cart_counter'>
                                {Bag &&
                                    <p>{Bag.length}</p>
                                }
                                </div>
                        </div>
                    </Link>
                    <Link to='/dashboard/listings/add'>
                        <div className='right_nav_element'>
                            <SignUpButton  Value="Sell"/>
                        </div>
                    </Link>
                    <button className='right_nav_element' onFocus={()=>{Toggle2(true)}} onBlur={()=>{Toggle2(false)}}>
                        <div style={{
                            padding:"1px",
                            border:"1px solid #2A2A2A",
                            borderRadius: "10px",
                            cursor:"pointer"
                        }} >
                            <div style={{
                                    width: "40px",
                                    paddingTop: "40px",
                                    borderRadius: "10px",
                                    position: "relative",
                                    backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+User.image})`,
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center'
                                }}>
                            </div>
                        </div>
                    </button>
                </>
            }
            {width <= ScreenSizes.Mobile &&
                <>
                    <Link to={"#"}>
                        <div className='right_nav_element' onClick={cartBoxToggle} style={{
                            position:"relative",
                            padding:"0px 10px"
                        }}>
                            <CartIcon width='22px' height='40px'/>
                            <div className='cart_counter'>
                                {Bag &&
                                    <p>{Bag.length}</p>
                                }
                                </div>
                        </div>
                    </Link>
                    {!menuOpen &&
                        <Link to='#'>
                            <div className='right_nav_element' onClick={()=>{
                                setMenuOpen(true)
                            }}>
                                <MenuBarIcon width='80px' height='80px'/>
                            </div>
                        </Link>
                    }
                    {menuOpen &&
                        <Link to='#'>
                            <div className='right_nav_element' onClick={()=>{
                                setMenuOpen(false)
                            }}  style={{transform:"rotate(45deg)"}}>
                                <CrossIcon width='80px' height='80px'/>
                            </div>
                        </Link>
                    }
                </>
            }
        </div>
        {User !== null &&
        <>
            <div className='rightnav_myprofile_dropdown' ref={myaccountBox}>
                <Link to={'/dashboard/index'}>
                    <div className='rightnav_myprofile_dropdown_item'>
                        <h6>Dashboard</h6>
                    </div>
                </Link>
                <Link to={'/user/'+User.username}>
                    <div className='rightnav_myprofile_dropdown_item'>
                        <h6>Profile</h6>
                    </div>
                </Link>
                <Link to={'#'} onClick={SignOut}>
                    <div className='rightnav_myprofile_dropdown_item'>
                        <h6>Sign Out</h6>
                    </div>
                </Link>
            </div>
            <div className='rightnav_notification_dropdown' ref={notificationBox}>
                <h4>Notifications</h4>
                {notifications.length === 0 &&
                    <h5>No notifications</h5>
                }
                {notifications.length !== 0 &&
                    notifications.map((item,index)=>{
                        return(
                            <Link to={item.url} key={index}>
                                <div className='rightnav_notification_dropdown_item'>
                                    <div className='rightnav_notification_dropdown_item_split'>
                                        <div className='rightnav_notification_dropdown_item_icon'>
                                            {item.title === 'new follower' &&
                                                <UserIcon width='18px' height='30px'/>
                                            }
                                            {item.title === 'new like' &&
                                                <HeartIcon width='18px' height='30px'/>
                                            }
                                            {item.title === 'new comment' &&
                                                <CommentIcon width='18px' height='30px'/>
                                            }
                                            {item.title === 'comment like' &&
                                                <CommentIcon width='18px' height='30px'/>
                                            }
                                        </div>
                                        <div className='rightnav_notification_dropdown_item_discription'>
                                            <p>{item.details}</p>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        )
                    })
                }
            </div>

            <div className='rightnav_notification_dropdown' ref={roomBox}>
                <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                    <h4>Messages</h4>
                    <Link to={'/dashboard/messages'}>More</Link>
                </div>
                {rooms.length === 0 &&
                    <h5>No messages</h5>
                }
                {rooms.length !== 0 &&
                    rooms.map((item,index)=>{
                        return(
                            <div className='rightnav_notification_dropdown_item' key={index} onClick={()=>{
                                addChatBox(item)
                            }}>
                                <div className='rightnav_notification_dropdown_item_split'>
                                    <div className='rightnav_notification_dropdown_item_icon'>
                                        <div 
                                            className='chat_boxes_item_image' 
                                            style={{
                                                backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+item.userimage})`
                                            }} 
                                            onClick={()=>{
                                                setOpenChatBox(item)
                                            }}
                                        >
                                        </div>
                                    </div>
                                    <div className='rightnav_notification_dropdown_item_discription'>
                                        <p>{item.first} {item.last}</p>
                                        <p>{item.username}</p>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </>
        }
        <div className='right_menu' ref={menuwrapperBox}>
            <div className='right_menu_container' ref={menucontainerBox}>
                {User !== null &&
                    <>
                        <div className='right_menu_profile'>
                            <div className='right_menu_profile_image'>
                                <label style={{cursor:"pointer"}}>
                                    <div style={{
                                        width: "100%",
                                        paddingTop: "80%",
                                        borderRadius: "10px",
                                        position: "relative",
                                        backgroundImage:`url(${ApiUrl.API_URL_Image_Collection+User.image})`,
                                        backgroundSize: 'cover',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'center',
                                        
                                    }}>
                                    <input type="file" style={{display:"none"}} onChange={showPreview}/>
                                    </div>
                                </label>
                            </div>
                            <div className='right_menu_profile_details'>
                                <h3>{User.firstname} {User.lastname}</h3>
                                <h4>@{User.username}</h4>
                                <Link to={'/dashboard/editprofile'} onClick={()=>{setMenuOpen(false)}}>
                                    <Button Value='Edit Profile' />
                                </Link>
                            </div>
                        </div>
                        <div className='right_menu_navbar'>
                            <Link to={'/dashboard/index'} onClick={()=>{setMenuOpen(false)}}>
                                <div className={currentRoute.includes('dashboard/index')? "dashboard_sidebar_menuitem_container active" : "dashboard_sidebar_menuitem_container"}>
                                    <div className='dashboard_sidebar_menuitem_border'></div>
                                    <div className='dashboard_sidebar_menuitem_icon'>
                                        {currentRoute.includes('dashboard/index') &&
                                            <HomeIcon fill='#2a2a2a' width={'20px'} height={'20px'}/>
                                        }
                                        {!currentRoute.includes('dashboard/index') &&
                                            <HomeIcon fill='#6D7175' width={'20px'} height={'20px'}/>
                                        }
                                    </div>
                                    <div className='dashboard_sidebar_menuitem_text'>
                                        <h6>Dashboard</h6>
                                    </div>
                                </div>
                            </Link>
                            <Link to={'/dashboard/liked'} onClick={()=>{setMenuOpen(false)}}>
                                <div className={currentRoute.includes('dashboard/liked')? "dashboard_sidebar_menuitem_container active" : "dashboard_sidebar_menuitem_container"}>
                                    <div className='dashboard_sidebar_menuitem_border'></div>
                                    <div className='dashboard_sidebar_menuitem_icon'>
                                        {currentRoute.includes('dashboard/liked') &&
                                            <HeartIcon fill='#2a2a2a' width={'20px'} height={'20px'}/>
                                        }
                                        {!currentRoute.includes('dashboard/liked') &&
                                            <HeartIcon fill='#6D7175' width={'20px'} height={'20px'}/>
                                        }
                                    </div>
                                    <div className='dashboard_sidebar_menuitem_text'>
                                        <h6>Liked</h6>
                                    </div>
                                </div>
                            </Link>
                            <Link to={'/dashboard/bookmarks'} onClick={()=>{setMenuOpen(false)}}>
                                <div className={currentRoute.includes('dashboard/bookmarks')? "dashboard_sidebar_menuitem_container active" : "dashboard_sidebar_menuitem_container"}>
                                    <div className='dashboard_sidebar_menuitem_border'></div>
                                    <div className='dashboard_sidebar_menuitem_icon'>
                                        {currentRoute.includes('dashboard/bookmarks') &&
                                            <BookmarksIcon fill='#2a2a2a' width={'20px'} height={'20px'}/>
                                        }
                                        {!currentRoute.includes('dashboard/bookmarks') &&
                                            <BookmarksIcon fill='#6D7175' width={'20px'} height={'20px'}/>
                                        }
                                    </div>
                                    <div className='dashboard_sidebar_menuitem_text'>
                                        <h6>Bookmarks</h6>
                                    </div>
                                </div>
                            </Link>
                            <Link to={'/dashboard/listings'} onClick={()=>{setMenuOpen(false)}}>
                                <div className={currentRoute.includes('dashboard/listing')? "dashboard_sidebar_menuitem_container active" : "dashboard_sidebar_menuitem_container"}>
                                    <div className='dashboard_sidebar_menuitem_border'></div>
                                    <div className='dashboard_sidebar_menuitem_icon'>
                                        {currentRoute.includes('dashboard/listing') &&
                                            <ListingIcon fill='#2a2a2a' width={'20px'} height={'20px'}/>
                                        }
                                        {!currentRoute.includes('dashboard/listing') &&
                                            <ListingIcon fill='#6D7175' width={'20px'} height={'20px'}/>
                                        }
                                    </div>
                                    <div className='dashboard_sidebar_menuitem_text'>
                                        <h6>Listing</h6>
                                    </div>
                                </div>
                            </Link>
                            <Link to={'/dashboard/orders'} onClick={()=>{setMenuOpen(false)}}>
                                <div className={currentRoute.includes('dashboard/orders')? "dashboard_sidebar_menuitem_container active" : "dashboard_sidebar_menuitem_container"}>
                                    <div className='dashboard_sidebar_menuitem_border'></div>
                                    <div className='dashboard_sidebar_menuitem_icon'>
                                        {currentRoute.includes('dashboard/orders') &&
                                            <OrdersIcon fill='#2a2a2a' width={'20px'} height={'20px'}/>
                                        }
                                        {!currentRoute.includes('dashboard/orders') &&
                                            <OrdersIcon fill='#6D7175' width={'20px'} height={'20px'}/>
                                        }
                                    </div>
                                    <div className='dashboard_sidebar_menuitem_text'>
                                        <h6>Orders</h6>
                                    </div>
                                </div>
                            </Link>
                            <Link to={'/dashboard/sales'} onClick={()=>{setMenuOpen(false)}}>
                                <div className={currentRoute.includes('dashboard/sales')? "dashboard_sidebar_menuitem_container active" : "dashboard_sidebar_menuitem_container"}>
                                    <div className='dashboard_sidebar_menuitem_border'></div>
                                    <div className='dashboard_sidebar_menuitem_icon'>
                                        {currentRoute.includes('dashboard/sales') &&
                                            <SalesIcon fill='#2a2a2a' width={'20px'} height={'20px'}/>
                                        }
                                        {!currentRoute.includes('dashboard/sales') &&
                                            <SalesIcon fill='#6D7175' width={'20px'} height={'20px'}/>
                                        }
                                    </div>
                                    <div className='dashboard_sidebar_menuitem_text'>
                                        <h6>Sales</h6>
                                    </div>
                                </div>
                            </Link>
                            <Link to={'/dashboard/insights'} onClick={()=>{setMenuOpen(false)}}>
                                <div className={currentRoute.includes('dashboard/insights')? "dashboard_sidebar_menuitem_container active" : "dashboard_sidebar_menuitem_container"}>
                                    <div className='dashboard_sidebar_menuitem_border'></div>
                                    <div className='dashboard_sidebar_menuitem_icon'>
                                        {currentRoute.includes('dashboard/insights') &&
                                            <InsighsIcon fill='#2a2a2a' width={'20px'} height={'20px'}/>
                                        }
                                        {!currentRoute.includes('dashboard/insights') &&
                                            <InsighsIcon fill='#6D7175' width={'20px'} height={'20px'}/>
                                        }
                                    </div>
                                    <div className='dashboard_sidebar_menuitem_text'>
                                        <h6>Insights</h6>
                                    </div>
                                </div>
                            </Link>
                            <Link to={'/dashboard/help'} onClick={()=>{setMenuOpen(false)}}>
                                <div className={currentRoute.includes('dashboard/help')? "dashboard_sidebar_menuitem_container active" : "dashboard_sidebar_menuitem_container"}>
                                    <div className='dashboard_sidebar_menuitem_border'></div>
                                    <div className='dashboard_sidebar_menuitem_icon'>
                                        {currentRoute.includes('dashboard/help') &&
                                            <HelpIcon fill='#2a2a2a' width={'20px'} height={'20px'}/>
                                        }
                                        {!currentRoute.includes('dashboard/help') &&
                                            <HelpIcon fill='#6D7175' width={'20px'} height={'20px'}/>
                                        }
                                    </div>
                                    <div className='dashboard_sidebar_menuitem_text'>
                                        <h6>Help</h6>
                                    </div>
                                </div>
                            </Link>
                            <Link to={'#'} onClick={()=>{setMenuOpen(false)}}>
                                <div className={"dashboard_sidebar_menuitem_container"} onClick={SignOut}>
                                    <div className='dashboard_sidebar_menuitem_border'></div>
                                    <div className='dashboard_sidebar_menuitem_icon' style={{
                                        transform:"scaleX(-1)"
                                    }}>
                                        <ShareIcon fill='#2a2a2a' width={'20px'} height={'20px'}/>
                                    </div>
                                    <div className='dashboard_sidebar_menuitem_text'>
                                        <h6>Sign Out</h6>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </>
                }
                {User === null&&
                    <div className='public_home_feed_signIn'>
                        <Link to='/login' onClick={()=>{setMenuOpen(false)}}><Button Value='Login'/></Link>
                        <p className='login_or_text'>OR</p>
                        <Link to='/signup' onClick={()=>{setMenuOpen(false)}}><LightButton Value='Signup'/></Link>
                    </div>
                }
                <div className='right_menu_socialmedia'>
                    <div className='social_Wrapper'>
                        <div className='social_Container'>
                            <a href='https://www.facebook.com/KAAYTHEEASYWAY' target='_blank' rel="noopener noreferrer"><div className='social_icon'><FacebookIcon width="15px" height='20px'/></div></a>
                            <a href='https://www.instagram.com/kaay_theeasyway/' target='_blank' rel="noopener noreferrer"><div className='social_icon'><InstagramIcon width="15px" height='20px'/></div></a>
                            <a href='https://www.pinterest.com/sesassociates3/' target='_blank' rel="noopener noreferrer"><div className='social_icon'><PinterestIcon width="15px" height='20px'/></div></a>
                            <a href='https://www.linkedin.com/company/%DA%A9%DB%92/' target='_blank' rel="noopener noreferrer"><div className='social_icon'><LinkedinIcon width="15px" height='20px'/></div></a>
                            <a href='https://twitter.com/' target='_blank' rel="noopener noreferrer"><div className='social_icon'><TwitterIcon width="15px" height='20px'/></div></a>
                            <a href='https://www.youtube.com/' target='_blank' rel="noopener noreferrer"><div className='social_icon'><YoutubeIcon width="15px" height='20px'/></div></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default RightNav
